<div class="card">
    <div class="card-header">
      <h4>Static QR Code Generation</h4>
    </div>
    <div class="card-body m-0">
        <div class="row">
            <div class="col-lg-4">
                 <ng-select #merchantDropDownList id="merchant" (change)="merchantChange($event)"  placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                   [(ngModel)]="merchant" >
                     <ng-option *ngFor="let merchant of merchantDropdown" [value]="merchant">
                       {{merchant.fullName}} ({{merchant.mobileNumber}})
                     </ng-option>
                   </ng-select>
               </div>
        </div>
        <hr>
        <div class="row" *ngIf="enableQR">
            <div class="row" style="align-items: center; justify-content: center">
                <div id="staticQrCodeCard" class="qr-card-large notranslate">
                  <!-- Fixed SVG Background -->
                  <img [src]="currentLang === 'ar' ? '/assets/images/pay10-qr-ar.svg' : '/assets/images/pay10-qr-fr.svg'" class="qr-card-bg" alt="Background poster">

                  <!-- Centered QR Code Overlay -->
                  <div class="qr-code-overlay">
                    <img [src]="qrCode" class="qr-code-img" alt="QR Code">
                  </div>

                  <!-- Centered Mobile Number/ID Text Overlay -->
                  <div [ngClass]="currentLang === 'ar' ? 'merchant-id-overlay' : 'merchant-id-overlay-fr'" [attr.dir]="currentLang === 'ar' ? 'rtl' : 'ltr'">
                   <div class="phone-number-span">{{ merchantIdentifier }}</div>
                  </div>
                </div>
              </div>
        </div>
        <!-- <div class="row" style="overflow: hidden;height: 0px;">
          <div class="row" style="align-items: center; justify-content: center">
              <div id="staticQrSmall" class="card" style="width: 220px; height: auto;">
                <br>
                <img src="/assets/images/pay10QRLogo.svg" style="width: 25%; margin: 0 40%" class="logo" alt="Logo">
                <div class="card-body">
                  <img [src]="qrCode" class="rounded float-start text-center" style="width: 80%; height: 80%; margin: 0 10%; border: 2px solid #e8e7e7; padding: 10px; margin-bottom: 10px;">
                  <h1 id="small-header-without-color" class="card-text text-center" >{{merchantName}}</h1>
                  <h3 id="h3-without-color-small" class="card-text text-center" style="margin-top: -20px;">Merchant ID:{{merchantIdentifier}}</h3>
                </div>
              </div>
            </div>
      </div> -->
        <br>
        <div class="row mb-2" *ngIf="enableQR" style="align-items: center; justify-content: center; gap: 15px;">
            <button type="button" style="width: auto; min-width: 180px;" class="btn bg-danger-custom" (click)="downloadQR('staticQrCodeCard', 'png')">
                Download PNG <i class="feather icon-download"></i>
            </button>
            <button type="button" style="width: auto; min-width: 180px;" class="btn bg-danger-custom" (click)="downloadQR('staticQrCodeCard', 'svg')">
                Download SVG <i class="feather icon-download"></i>
            </button>
            <button type="button" style="width: auto; min-width: 180px;" class="btn bg-danger-custom" (click)="printDualQRCode()">
                Print A4 (AR & FR) <i class="feather icon-printer"></i>
            </button>
            <button type="button" style="width: auto; min-width: 180px;" class="btn bg-danger-custom" (click)="printQRCodeA5InA4()">
                Print SVG (A5 in A4) <i class="feather icon-printer"></i>
            </button>
        </div>
    </div>
  </div>


